import { AppDispatch } from "../../app/store";

export enum validationType {
    name,
    normal
}

export const validate = (dispatch: AppDispatch, setError: (id: string) => { payload: string, type: string },
    resetError: (id: string) => { payload: string, type: string }, input: string | null, id: string, type: validationType = validationType.normal): boolean => {
    let invalidInput = false;
    switch (type) {
        case validationType.name: {
            invalidInput = input ? justNameValidate(input) : false;
            break;
        }
        default: {
            invalidInput = input ? justNormalValidate(input) : false;
            break;
        }
    }
    invalidInput ? dispatch(setError(id)) : dispatch(resetError(id));
    return invalidInput;
}

export const validateHelper = (input: string | null, type: validationType = validationType.normal): string => {
    let helperText = "";
    switch (type) {
        case validationType.name: {
            helperText = "Folgende Zeichen sind erlaubt: a-z und 0-9.";
            break;
        }
        default: {
            helperText = "Folgende Zeichen sind erlaubt: a-z, A-Z, 0-9, ö,ü,ä, Ö, Ü, Ä, -, /, (, ), ., : und Leerzeichen.";
        }
    }
    return input && justNormalValidate(input) ? helperText : "";
}

export const justNormalValidate = (input: string): boolean => {
    let invalidInput = false;
    if (input ? input.length > 0 : false) {
        const regex = new RegExp("^[a-zA-Z0-9äöüÄÖÜß\\s\\-\\/\\(\\)\\.\\:]{1,50}$")
        if (!regex.test(input))
            invalidInput = true;
    }
    return invalidInput;
}

const justNameValidate = (input: string): boolean => {
    let invalidInput = false;
    if (input.length > 0) {
        const regex = new RegExp("^[a-z0-9]{1,50}$")
        if (!regex.test(input))
            invalidInput = true;
    }
    return invalidInput;
}
